<main>
  <app-header></app-header>
  <modal-dialog></modal-dialog>
  <loading-screen></loading-screen>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <div class="footer">
    <button *ngIf="startOverButtonEnabled" class="link" (click)="backToCompanies()">{{ "BACK_TO_COMPANY_LIST" | translate }}</button>
  </div>
</main>

<div class="version caption" [ngClass]="{ 'shown': showVersion}">v. {{ appVersion }}</div>
